;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.invoice.list')
    .controller('QuoteListToolbarController', QuoteListToolbarController)

  QuoteListToolbarController.$inject = [
    // Urls
    'urls',

    // Angular
    '$uibModal', '$http',

    // Services
    'LedgerService', 'QuoteService', 'FilterService'

  ]

  function QuoteListToolbarController (
    // Urls
    urls,

    // Angular
    $uibModal, $http,

    // Services
    LedgerService, QuoteService, FilterService

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        // Public Method
        exportSearch
      })
    }

    function exportSearch () {
      const conditions = FilterService.parseQueryTree(angular.copy(self.$resolve.pagination.search))
      const total = angular.copy(self.$resolve.pagination.totalElements)
      return QuoteService.searchToSpreadsheet(conditions, total)
    }
  }
})(window.angular, window._, window.moment)
